import { useClip } from "../../contexts/Clip";
import { useProgress } from "../../contexts/Progress";
import { useRoot } from "../../contexts/Root";
import { Bar } from "./Bar";

export const ProgressBar = () => {
  const {
    theme: { emphasis },
  } = useRoot();

  const { show: showClip } = useClip();
  const { offset } = useProgress();

  return <Bar show={!showClip} width={offset} zIndex={2} color={emphasis} />;
};
